<template>
    <div style="padding-bottom: 20px;width: 100%;">
        <img src="@/assets/web/index/register-top.png"/>
        <el-row style="margin: 20px;">
            <el-form ref="form" :model="form" :rules="rules" size="small" label-width="100px">
                <el-col :span="24">
                    <el-form-item label="单位名称：" prop="orgName">
                        <el-input
                                v-model="form.orgName"
                                maxlength="100"
                                placeholder="单位名称"
                                :disabled="disabled"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="单位类型：" prop="orgNature">
                        <dict-select
                                type="org_nature"
                                v-model="form.orgNature"
                                maxlength="20"
                                placeholder="单位类型"
                                :disabled="disabled"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="所在地区：" prop="area">
                        <area-cascader
                                v-model="form.area"
                                maxlength="20"
                                placeholder="所在地区"
                                :disabled="disabled"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="地址：" prop="address">
                        <el-input
                                v-model="form.address"
                                maxlength="255"
                                placeholder="地址"
                                :disabled="disabled"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="联系人：" prop="linkman">
                        <el-input
                                v-model="form.linkman"
                                maxlength="50"
                                placeholder="联系人"
                                :disabled="disabled"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="联系电话：" prop="linkmanMobile">
                        <el-input
                                v-model="form.linkmanMobile"
                                maxlength="50"
                                placeholder="联系电话"
                                :disabled="disabled"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="短信验证码：" prop="code">
                        <sms-code-input v-model="form.code" source="register" :mobile="form.linkmanMobile"/>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="联系人邮箱：" prop="linkmanEmail">
                        <el-input
                                v-model="form.linkmanEmail"
                                maxlength="50"
                                placeholder="联系人邮箱"
                                :disabled="disabled"
                        />
                    </el-form-item>
                </el-col>
            </el-form>
        </el-row>
        <div style="text-align: right;padding-right: 20px;">
            <el-button type="text" @click="done(false)">
                取消
            </el-button>
            <el-button :loading="loading" type="primary" @click="submit" v-if="!disabled">
                确认
            </el-button>
        </div>
    </div>
</template>

<script>
import myRules from '@/utils/rules'
import AreaCascader from '@/components/Area/AreaCascader.vue'
import request from '@/utils/request'
import SmsCodeInput from '@/components/Sms/SmsCodeInput.vue'
import {isMobile} from "@/utils";

export default {
    name: 'Register',
    components: {SmsCodeInput, AreaCascader},
    props: {},
    data() {
        return {
            dialog: false,
            disabled: false,
            loading: false,
            form: {
                orgId: null, // 机构ID
                orgNo: null, // 机构编码
                pid: null, // 上级机构
                orgName: null, // 机构名称
                shortName: null, // 机构简称
                province: null, // 省
                city: null, // 市
                area: null, // 区
                path: null, // 父级路径
                address: null, // 地址
                linkman: null, // 联系人
                linkmanMobile: '', // 联系电话
                code: '', // 验证码
                linkmanEmail: null, // 联系人邮箱
                openTime: null, // 上班时间
                closeTime: null, // 下班时间
                orgType: null, // 机构类型
                orgNature: null, // 机构性质
                pinYin: null, // 机构拼音
                orgLogo: null, // 机构logo
                longitude: null, // 经度
                latitude: null, // 维度
                password: null, // 门店密码
                sort: null, // 排序
                status: null, // 状态
                introduction: null, // 简介
                distFlag: null, // 是否分销
                remark: null, // 备注
                createTime: null, // 创建日期
                createBy: null, // 创建人
                updateTime: null, // 更新日期
                updateBy: null // 更新人
            },
            rules: {
                orgId: [{required: true, validator: myRules.required, trigger: 'blur'}],
                orgNo: [{required: true, validator: myRules.required, trigger: 'blur'}],
                pid: [{required: true, validator: myRules.required, trigger: 'blur'}],
                area: [{required: true, validator: myRules.required, trigger: 'blur'}],
                address: [{required: true, validator: myRules.required, trigger: 'blur'}],
                orgName: [{required: true, validator: myRules.required, trigger: 'blur'}],
                linkman: [{required: true, validator: myRules.required, trigger: 'blur'}],
                linkmanMobile: [
                    {required: true, validator: myRules.required, trigger: 'blur'},
                    {validator: myRules.mobile, trigger: 'blur'}
                ],
                code: [{validator: myRules.required, trigger: 'blur'}],
                linkmanEmail: [{validator: myRules.email, trigger: 'blur'}],
                orgNature: [{required: true, validator: myRules.required, trigger: 'blur'}],
                status: [{required: true, validator: myRules.required, trigger: 'blur'}]
            }
        }
    },
    watch: {
        action: function (val) {
            this.disabled = val === 'view'
        },
        dialog: function (val) {
            if (!val) {
                this.clearForm()
            }
        }
    },
    methods: {
        /**
         * 提交
         */
        submit() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.loading = true
                    request({
                        url: '/register/add',
                        method: 'post',
                        data: this.form
                    })
                        .then(res => {
                            this.loading = false
                            this.done(true)
                            this.$alert(
                                `已申请试用成功！用户名：${res.data.username}，密码：${res.data.password}`,
                                '提示',
                                {
                                    confirmButtonText: '确定'
                                }
                            )
                        })
                        .catch(err => {
                            this.loading = false
                            console.error('新增错误！', err)
                        })
                }
            })
        },
        /**
         * 清理表单
         */
        clearForm() {
            this.$refs['form'].resetFields()
            this.form = {
                orgId: null, // 机构ID
                orgNo: null, // 机构编码
                pid: null, // 上级机构
                orgName: null, // 机构名称
                shortName: null, // 机构简称
                province: null, // 省
                city: null, // 市
                area: null, // 区
                path: null, // 父级路径
                address: null, // 地址
                linkman: null, // 联系人
                linkmanMobile: '', // 联系电话
                code: '', // 联系电话
                linkmanEmail: null, // 联系人邮箱
                openTime: null, // 上班时间
                closeTime: null, // 下班时间
                orgType: null, // 机构类型
                orgNature: null, // 机构性质
                pinYin: null, // 机构拼音
                orgLogo: null, // 机构logo
                longitude: null, // 经度
                latitude: null, // 维度
                password: null, // 门店密码
                sort: null, // 排序
                status: null, // 状态
                introduction: null, // 简介
                distFlag: null, // 是否分销
                remark: null, // 备注
                createTime: null, // 创建日期
                createBy: null, // 创建人
                updateTime: null, // 更新日期
                updateBy: null // 更新人
            }
        },
        /**
         * 完成
         */
        done(refresh) {
            if (isMobile()) {
                this.$router.push({path: '/'})
            } else {
                this.$emit('done', refresh)
            }

        }
    }
}
</script>

<style lang="scss">
.el-dialog__header {
  padding: 0px !important;
}
</style>
